import { Invoice } from '../../../../../../app/entities/Invoice'
import isTransactionProcessing from './is-transaction-processing'
import isTransactionSettled from './is-transaction-settled'

// This function should be mirrored in app/eworkflows/invoice/status/is-transaction-charged.ts
function isTransactionCharged(invoice: Invoice) {
  return isTransactionProcessing(invoice) || isTransactionSettled(invoice)
}

export default isTransactionCharged